import React, { useState, useEffect } from "react";
import api from "../constant/api";

export default function AIQuestionManager() {
  const [faqs, setFaqs] = useState([]);
  const [isOpen, setIsOpen] = useState(false); 
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  // 1. விபரங்களை லோடு செய்ய
  const fetchFaqs = async () => {
    try {
      const res = await api.get("/ai/getFaqCommands"); 
      if (res.data && res.data.data) {
        setFaqs(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  // 2. Insert அல்லது Edit சேமிக்க
  const handleSave = async (e) => {
    e.preventDefault();
    if (!question || !answer) return alert("Please fill all fields!");

    setLoading(true);
    try {
      if (editId) {
        await api.put(`/ai/updateFaq/${editId}`, { question, answer });
        alert("மாற்றப்பட்டது!");
      } else {
        await api.post("/ai/addFaq", { question, answer });
        alert("சேமிக்கப்பட்டது!");
      }
      closeModal();
      fetchFaqs(); 
    } catch (error) {
      console.error("API Error:", error);
      alert("Error saving data");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (faq) => {
    setEditId(faq.id || faq._id);
    setQuestion(faq.question);
    setAnswer(faq.answer);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setQuestion("");
    setAnswer("");
    setEditId(null);
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)",
        padding: "16px", // மொபைலுக்காக பேடிங் குறைக்கப்பட்டுள்ளது
        color: "#f8fafc",
        fontFamily: "sans-serif",
        boxSizing: "border-box",
      }}
    >
      {/* 🌟 மொபைல் ரெஸ்பான்சிவ் ஸ்டைல் டேக் */}
      <style>{`
        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1000px;
          margin: 0 auto 24px auto;
          gap: 16px;
        }
        .add-btn {
          padding: 12px 24px;
          background: linear-gradient(180deg, #10b981 0%, #047857 100%);
          border: none;
          border-radius: 12px;
          color: #fff;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3), inset 0 1px 0 rgba(255,255,255,0.2), 0 4px 0 #064e3b;
          transition: all 0.1s ease;
          width: auto;
        }
        .cards-container {
          display: none;
        }
        .table-container {
          display: block;
          max-width: 1000px;
          margin: 0 auto;
          background: rgba(30, 41, 59, 0.6);
          backdrop-filter: blur(12px);
          border-radius: 20px;
          border: 1px solid rgba(255,255,255,0.05);
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
          overflow: hidden;
        }
        .modal-body {
          width: 100%;
          max-width: 480px;
          background: #1e293b;
          border-radius: 24px;
          padding: 24px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.05);
          position: relative;
          box-sizing: border-box;
          margin: auto 8px;
        }

        /* 📱 சிறிய மொபைல் திரைகளுக்கான பிரத்யேக ஸ்டைல் (Responsive Media Queries) */
        @media (max-width: 640px) {
          .top-bar {
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            gap: 12px;
          }
          .add-btn {
            width: 100%; /* மொபைலில் பட்டன் முழு அகலத்திற்கு மாறும் */
            text-align: center;
          }
          .table-container {
            display: none; /* மொபைலில் கடினமான டேபிளுக்கு பதிலாக கார்டு வியூ காட்டப்படும் */
          }
          .cards-container {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-width: 1000px;
            margin: 0 auto;
          }
          .mobile-card {
            background: rgba(30, 41, 59, 0.7);
            border: 1px solid rgba(255,255,255,0.05);
            border-radius: 16px;
            padding: 16px;
            box-shadow: 0 4px 10px rgba(0,0,0,0.2);
          }
        }
      `}</style>

      {/* 🌟 Top Bar & Add Button */}
      <div className="top-bar">
        <div>
          <h2 style={{ margin: 0, fontSize: "1.6rem", fontWeight: "700", color: "#38bdf8" }}>AI Q&A Bank</h2>
          <p style={{ margin: "4px 0 0 0", fontSize: "0.85rem", color: "#94a3b8" }}>வாய்ஸ் அசிஸ்டெண்ட் கேள்வி பதில் பட்டியல்</p>
        </div>

        <button
          onClick={() => setIsOpen(true)}
          className="add-btn"
          onMouseDown={(e) => { e.currentTarget.style.transform = "translateY(4px)"; e.currentTarget.style.boxShadow = "0 2px 4px rgba(16, 185, 129, 0.2), 0 0px 0 #064e3b"; }}
          onMouseUp={(e) => { e.currentTarget.style.transform = "translateY(0px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.3), 0 4px 0 #064e3b"; }}
        >
          + Add New FAQ
        </button>
      </div>

      {/* 💻 பெரிய திரைகளுக்கான டேபிள் வியூ (Table View for Desktop/Tablet) */}
      <div className="table-container">
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
            <thead>
              <tr style={{ background: "rgba(15, 23, 42, 0.8)", color: "#cbd5e1" }}>
                <th style={{ padding: "16px", fontSize: "0.9rem", fontWeight: "600" }}>Question (கேள்வி)</th>
                <th style={{ padding: "16px", fontSize: "0.9rem", fontWeight: "600" }}>Answer (பதில்)</th>
                <th style={{ padding: "16px", fontSize: "0.9rem", fontWeight: "600", width: "100px", textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {faqs.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                    background: index % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent",
                  }}
                >
                  <td style={{ padding: "16px", fontSize: "0.9rem", color: "#f1f5f9" }}>{item.question}</td>
                  <td style={{ padding: "16px", fontSize: "0.9rem", color: "#94a3b8" }}>{item.answer}</td>
                  <td style={{ padding: "16px", textAlign: "center" }}>
                    <button
                      onClick={() => handleEdit(item)}
                      style={{
                        padding: "6px 14px",
                        background: "rgba(99, 102, 241, 0.2)",
                        border: "1px solid #6366f1",
                        borderRadius: "8px",
                        color: "#818cf8",
                        cursor: "pointer",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        transition: "all 0.2s",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "#6366f1"; e.currentTarget.style.color = "#fff"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(99, 102, 241, 0.2)"; e.currentTarget.style.color = "#818cf8"; }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
              {faqs.length === 0 && (
                <tr>
                  <td colSpan="3" style={{ padding: "32px", textAlign: "center", color: "#64748b", fontSize: "0.9rem" }}>
                    No data found. விபரங்கள் எதுவும் இல்லை.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* 📱 சிறிய மொபைல் திரைகளுக்கான ஸ்மார்ட் கார்டு வியூ (Card View for Mobile) */}
      <div className="cards-container">
        {faqs.map((item, index) => (
          <div key={index} className="mobile-card">
            <div style={{ marginBottom: "8px" }}>
              <span style={{ fontSize: "0.75rem", color: "#38bdf8", fontWeight: "bold", uppercase: "true" }}>QUESTION:</span>
              <div style={{ fontSize: "0.95rem", color: "#f1f5f9", marginTop: "2px", fontWeight: "500" }}>{item.question}</div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <span style={{ fontSize: "0.75rem", color: "#a78bfa", fontWeight: "bold" }}>ANSWER:</span>
              <div style={{ fontSize: "0.85rem", color: "#94a3b8", marginTop: "2px", lineHeight: "1.4" }}>{item.answer}</div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => handleEdit(item)}
                style={{
                  padding: "8px 16px",
                  background: "#6366f1",
                  border: "none",
                  borderRadius: "8px",
                  color: "#fff",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  width: "100%",
                  cursor: "pointer"
                }}
              >
                Edit Data
              </button>
            </div>
          </div>
        ))}
        {faqs.length === 0 && (
          <div style={{ padding: "32px", textAlign: "center", color: "#64748b", fontSize: "0.9rem" }}>
            No data found. விபரங்கள் எதுவும் இல்லை.
          </div>
        )}
      </div>

      {/* 🌟 3D Responsive Modal Pop-up Form */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(15, 23, 42, 0.85)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            zIndex: 9999,
            boxSizing: "border-box"
          }}
        >
          <div className="modal-body">
            <h3 style={{ margin: "0 0 20px 0", fontSize: "1.3rem", color: "#f8fafc" }}>
              {editId ? "Edit Q&A Data" : "Create New Q&A"}
            </h3>

            <form onSubmit={handleSave} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "0.85rem", color: "#cbd5e1" }}>Question (கேள்வி)</label>
                <input
                  type="text"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  placeholder="எ.கா: யார் இந்த சாப்ட்வேர் செஞ்சது"
                  style={{
                    width: "100%", padding: "12px", background: "#0f172a",
                    border: "1px solid #334155", borderRadius: "12px", color: "#fff",
                    outline: "none", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.5)", boxSizing: "border-box"
                  }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "0.85rem", color: "#cbd5e1" }}>Answer (AI பதில்)</label>
                <textarea
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  placeholder="எ.கா: இந்த சாப்ட்வேர் AK CRM குழுவினர் தயாரிப்பு."
                  style={{
                    width: "100%", height: "100px", padding: "12px", background: "#0f172a",
                    border: "1px solid #334155", borderRadius: "12px", color: "#fff",
                    outline: "none", resize: "none", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.5)", boxSizing: "border-box"
                  }}
                />
              </div>

              {/* Action Buttons inside Modal */}
              <div style={{ display: "flex", gap: "12px", marginTop: "10px" }}>
                <button
                  type="button"
                  onClick={closeModal}
                  style={{
                    flex: 1, padding: "12px", background: "#334155", border: "none",
                    borderRadius: "12px", color: "#fff", cursor: "pointer", fontWeight: "600"
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    flex: 1, padding: "12px",
                    background: "linear-gradient(180deg, #4f46e5 0%, #3730a3 100%)",
                    border: "none", borderRadius: "12px", color: "#fff", fontWeight: "600",
                    cursor: "pointer", boxShadow: "0 4px 12px rgba(79, 70, 229, 0.4), 0 4px 0 #1e1b4b"
                  }}
                >
                  {loading ? "Saving..." : "Save Data"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}